import { InlineStack, Text, Toggle } from '@customerio/pluma-components/react';
import { formatLongTimestamp } from '@/utils/calendar-timestamps';

type AutoRefreshControlProps = {
  /** Epoch millis of the last successful fetch (`0` ⇒ not loaded yet → em dash). */
  lastUpdated: number;
  autoRefresh: boolean;
  onAutoRefreshChange: (next: boolean) => void;
};

/**
 * "Last updated <time>" + an "Auto refresh" toggle — the toolbar status shown on
 * the Activity Logs and Outbox lists (ported from the Ember `<ScheduledTask>`).
 * Presentational: the owner supplies the timestamp and toggle state (see
 * `useAutoRefresh` for the flag-backed state, and drives polling itself).
 */
export function AutoRefreshControl({ lastUpdated, autoRefresh, onAutoRefreshChange }: AutoRefreshControlProps) {
  return (
    <InlineStack alignBlock="center" gap="100">
      <Text size="sm" color="subtle">
        {lastUpdated > 0 ? (
          <>Last updated {formatLongTimestamp(Math.floor(lastUpdated / 1000), new Date(), { capitalize: false })}</>
        ) : (
          'Last updated —'
        )}
      </Text>
      <Text size="sm">Auto refresh</Text>
      <Toggle
        ariaLabel="Auto refresh"
        isChecked={autoRefresh}
        onChange={() => onAutoRefreshChange(!autoRefresh)}
        size="sm"
      />
    </InlineStack>
  );
}
